























import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import {grabTodoListInstance} from '@/model/GrabTodoListClass';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;

@Component({
  name: 'GrabTodos',
})
export default class GrabTodos extends Vue {
  @Ref() private readonly rollingWrapper!: HTMLDivElement;
  private grabTodoListInstance = grabTodoListInstance;
  private rollingNum = 0;
  private rollingInterval = 3000;
  private rollingTimer: unknown = 0;
  private direction = 1;
  get todos() {
    return this.grabTodoListInstance.list.filter((todo) => !todo.rejectComment && !todo.grabComment);
  }
  get maxWidth() {
    return this.todos.length * 480;
  }
  @Watch('todos')
  private watchTodosChange(newValue: IGrabTodoInfo[]) {
    this.rollingNum = 0;
    this.startRolling();
  }
  private startRolling() {
    if (this.rollingTimer) {
      this.stopRolling();
    }
    if (this.todos.length <= 1) {
      return;
    }
    this.rollingTimer = setInterval(() => {
      if (Math.abs(this.rollingNum) === (this.todos.length - 1) * 480) {
        this.direction = -1;
      }
      if (this.rollingNum === 0) {
        this.direction = 1;
      }
      this.rollingNum -= 480 * this.direction;
    }, this.rollingInterval);
  }
  private stopRolling() {
    clearInterval(this.rollingTimer as any);
  }
  private created() {
    this.grabTodoListInstance.requestGrabTodoList();
  }
  private beforeDestroy() {
    this.stopRolling();
  }
  private goGrabTodoPage(todoId: string) {
    if (this.$router.currentRoute.name !== 'GrabTodo') {
      this.$router.push({
        name: 'GrabTodo',
        params: {
          id: todoId,
          tabKey: 'grab',
        },
      });
    }
  }
}
